import React from 'react';

const { Suspense } = React;
interface Props {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

const ErrorAlert = React.lazy(() => import('../Alert/ErrorAlert'));

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundryError:', error);
    // eslint-disable-next-line no-console
    console.error('ErrorBoundryErrorInfo:', errorInfo);

    if (typeof window !== 'undefined' && window?.elasticApm?.captureError) {
      window.elasticApm.captureError(error);
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Suspense fallback={null}>
          <ErrorAlert />
        </Suspense>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
